import React from 'react';

import { useOrgData } from '../../hooks/useOrgData';
import { AnonymousExperimentProvider } from '../../resources/amplitude/AnonymusProvider';
import { useRecaptcha } from '../../resources/google/useRecaptcha';
import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { Spinner } from '../Spinner';

import HomeOwnerFlowDialog from './HomeOwnerFlowDialog';

export const detectIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const HomeOwnerFlowDialogWrapper = () => {
  const {
    state: { token },
  } = useOnlineBookingReducer();

  const { isLoading, isFetched, data } = useOrgData({ token });
  useRecaptcha();

  if (isLoading || !isFetched) {
    return <Spinner show />;
  }

  const orgEmail = data?.email;

  return (
    <AnonymousExperimentProvider proId="NoProID" email={orgEmail}>
      <HomeOwnerFlowDialog />
    </AnonymousExperimentProvider>
  );
};

export default HomeOwnerFlowDialogWrapper;
